import { type HttpServiceConfig } from './httpService'

/**
 * Service for making HTTP requests to FOM backend.
 */
export default class FomUploadService {
  private baseURL: string | null | undefined
  private token: string | null | undefined

  constructor(config: HttpServiceConfig) {
    this.baseURL = config.baseUrl
    this.token = config.token
  }

  /**
   * Get the generic headers needed for making requests to the backend.
   */
  private getRequestHeaders(): HeadersInit {
    const headers: HeadersInit = {}
    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`
    }
    return headers
  }

  public async uploadProjectFile(
    projectId: number | string,
    headerId: number,
    headerName: string,
    file: File,
  ): Promise<[number, string]> {
    const formData = new FormData()

    if (file.size > 30 * 1024 * 1024) {
      throw new Error('File size exceeds the limit of 30MB')
    }

    formData.append('file', file)
    const response = await fetch(
      `${this.baseURL}/uploadProjectFile?projectId=${projectId}&headerId=${headerId}&headerName=${encodeURIComponent(
        headerName,
      )}`,
      {
        method: 'POST',
        headers: {
          ...this.getRequestHeaders(),
        },
        body: formData,
      },
    )

    if (!response.ok) {
      console.error('Failed to upload project file:', response.statusText)
      throw new Error('Server error status ' + response.status)
    }

    const fileData = await response.json()
    return [fileData.id, fileData.url]
  }

  public async deleteProjectFile(fileId: number): Promise<void> {
    const response = await fetch(`${this.baseURL}/deleteProjectFile?fileId=${fileId}`, {
      method: 'DELETE',
      headers: {
        ...this.getRequestHeaders(),
      },
    })

    if (!response.ok) {
      console.error('Failed to delete project file:', response.statusText)
      throw new Error('Server error status ' + response.status)
    }
  }
}
